import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaFileAlt } from 'react-icons/fa';
import './Sidebar.css';
import { FaUserAlt } from "react-icons/fa";
import { BiSolidCategoryAlt } from "react-icons/bi";

import { MdOutlineProductionQuantityLimits } from "react-icons/md";

const Sidebar = () => {
  
  const location = useLocation();

   const MenuItem = ({ icon, label, to }) => {
    const isActive = location.pathname.startsWith(to); // ✅ check if current path starts with `to`

    return (
      <li className={isActive ? 'active-sidebar-item' : ''}>
        <Link to={to} className="sidebar-link">
          {icon} <span>{label}</span>
        </Link>
      </li>
    );
  };



  return (
    <div className="sidebar   p-3" style={{backgroundColor:"#819A91", width:"15%", height: "calc(100vh - 70px)", position:"fixed", top:"65px", left:"0px",overflowY: "auto"}}>
      <ul className="nav flex-column gap-2">
        <MenuItem icon={<FaHome className="me-2" />} label="Dashboard" to="/dashboard" />
        <MenuItem icon={<BiSolidCategoryAlt className="me-2"/>} label="Category" to="/category"/>    
        

        <MenuItem icon={<FaFileAlt className="me-2" />} label="Products" to="/product" />
        <MenuItem icon={<FaUserAlt className='me-2'/>} label="Users" to="/users" />

        <MenuItem icon={<MdOutlineProductionQuantityLimits className='me-2'/>} label="Orders" to="/orders" />
      </ul>
    </div>
  );
};

export default Sidebar;
